export default {
    meta: {
        title: 'Demo 展示'
    }
};
